module.exports = __webpack_public_path__ + "static/media/success-circle.75aeb4af.svg";